import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=f63e87ae&scoped=true&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=f63e87ae&scoped=true&lang=css&"
import style1 from "./ContextMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63e87ae",
  null
  
)

export default component.exports